import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { environment } from "../../../environments/environment";
import { Buffer } from 'buffer';

@Component({
  selector: 'app-grab-miniapp-dialog',
  templateUrl: './grab-miniapp-dialog.component.html',
  styleUrls: ['./grab-miniapp-dialog.component.scss']
})
export class GrabMiniappDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
  }

  openGrabApp() {
    const currentUrl = new URL(this.data.redirectUrl);
    const baseUrl = `${environment.grabMiniApp.webviewUrl}/grabid/v1/oauth2/grablet/config`;

    const queryParams = new URLSearchParams({
      client_id: environment.grabMiniApp.clientId,
      redirect_url: currentUrl.origin
    });

    const webviewUrl = `${baseUrl}?${queryParams.toString()}`;
    
    const sessionParamsObj = {
      linkId: this.data.linkId
    };
    const sessionParamsStr = JSON.stringify(sessionParamsObj);
    const sessionParamsBase64 = (this.data.linkId) ? Buffer.from(sessionParamsStr).toString('base64') : null;

    let deepLink = `grab://open?screenType=CONSENT&webviewUrl=${encodeURIComponent(webviewUrl)}&miniapp=true`;

    if (sessionParamsBase64 != null) {
      deepLink += `&sessionParams=${sessionParamsBase64}`;
    }

    window.location.href = deepLink;
  }
}

export interface DialogData {
  redirectUrl: string,
  linkId: string
}